import { getAgeByRegion } from 'app/packages/region';

import useCurrentRegion from './useCurrentRegion';

const useAdultAge = () => {
  const currentRegion = useCurrentRegion();

  return getAgeByRegion(currentRegion);
};

export default useAdultAge;
